function Header() {
	return (
		<header>
			<h1>Guessing game</h1>
		</header>
	);
}

export default Header;
